import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import ApiService from './services/api.service';
import moment from 'moment';
import { Mask, vMaska } from 'maska';
import VueSignature from './stylus';
// import 'roboto-fontface/css/roboto/roboto-fontface.css';
// import '@mdi/font/css/materialdesignicons.css';

import './assets/css/index.css';
import './assets/css/index.scss';
import translate from '@/utils/translate.util';
// import 'material-design-icons-iconfont/dist/material-design-icons.css';

ApiService.init(process.env.VUE_APP_ROOT_API);
ApiService.mountInterceptor(error => {
    let message = 'Произошла ошибка';
    let color = 'error';
    let isApi = false;

    const res = error.response;

    if (res) {
        switch (res.status) {
            case 401:
                store.dispatch('auth/logout');
                return Promise.reject(error);
            case 400:
                message = translate(res.data.message, 'full').name;
                color = 'warning';
                isApi = true;
                break;
            case 500:
                console.error(res.data.message);
                break;
            case 502:
            case 503:
                store.dispatch('health/changeSystemStatus');
                break;
        }
    } else if (error.message) {
        message = error.message;
    } else {
        return error;
    }

    if ([502, 503].includes(res.status)) return Promise.reject(error);
    store.dispatch('base/showMessage', { color, message, isApi });
    return Promise.reject(error);
});

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY');
    }
});
Vue.filter('formatDecimal', function(value) {
    if (value || value === 0) {
        const fixedValue = Number(value).toFixed(3);
        const dotIndex = fixedValue.indexOf('.');

        const float = fixedValue.substr(dotIndex + 1);
        const real = fixedValue.substring(0, dotIndex);
        const parsedReal = new Intl.NumberFormat().format(real);

        return `${parsedReal}.${float}`;
    }
});

Vue.filter('formatDateFull', function(value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY HH:mm');
    }
});

Vue.filter('showFistTwoWords', function(value) {
    if (value) {
        let words = value.split(' ');
        return words[0] + ' ' + words[1] + '...';
    }
});

Vue.filter('replaceDelimiter', function(value) {
    if (value) {
        return value.replace(/,/g, ', ');
    }
});

Vue.filter('showArrayAsText', function(items) {
    if (items) {
        let text = '';
        for (let [key, value] of items.entries()) {
            // в конце запятую не ставим
            if (items.length === key + 1) {
                text += value;
            } else {
                text += value + ', ';
            }
        }
        return text;
    } else {
        return '<не определено>';
    }
});

Vue.config.productionTip = false;

new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');

Vue.directive('maska', vMaska);

export const mask = new Mask({ mask: '+7 (###) ###-##-##' });
